import type { SelectChangeEvent } from "@mui/material/Select";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import type { ArrayElement } from "../../../misc/ArrayElement";
import { ProviderProductType } from "../../providers/providersApi";
import { isEmpty, sortBy } from "lodash";
import InputAdornment from "@mui/material/InputAdornment";
import Clear from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";

const providerProductTypeGroup: Record<ProviderTypeSelectValue, ProviderProductType[]> = {
  Hotel: [ProviderProductType.HOTEL, ProviderProductType.HOTEL_VAT_NP],
  Atrakcja: [ProviderProductType.ATTRACTION],
};

const allProductTypes = Object.values(providerProductTypeGroup).flat();
export function asProviderProductType(value: ProviderTypeSelectValue[]): ProviderProductType[] {
  if (isEmpty(value)) {
    return allProductTypes;
  }
  return value.flatMap((v) => providerProductTypeGroup[v]);
}

const types = ["Hotel", "Atrakcja"] as const;
export type ProviderTypeSelectValue = ArrayElement<typeof types>;

export function ProviderTypeSelect(props: {
  onChange: (values: ProviderTypeSelectValue[]) => void;
  values: ProviderTypeSelectValue[];
}) {
  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const {
      target: { value },
    } = event;
    const values: string[] = typeof value === "string" ? value.split(",") : value;
    props.onChange(values as ProviderTypeSelectValue[]);
  };
  const label = "Typ dostawcy";
  return (
    <FormControl>
      <InputLabel id="ProviderTypeSelect">{label}</InputLabel>
      <Select
        label={label}
        labelId="ProviderTypeSelect"
        fullWidth
        multiple
        value={props.values}
        onChange={handleChange}
        endAdornment={
          <InputAdornment position="end">
            <IconButton onClick={() => props.onChange([])} style={{ marginRight: 16 }}>
              <Clear />
            </IconButton>
          </InputAdornment>
        }
        renderValue={(selected) => sortBy(selected).join(", ")}
      >
        {types.map((type) => (
          <MenuItem key={type} value={type}>
            <Checkbox checked={props.values.includes(type)} />
            <ListItemText primary={type} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
